import { createReducer, on } from '@ngrx/store';
import { TutorialsActions } from './tutorials.actions';
import { TutorialsState } from './tutorials.state';

export const initTutorialsState: TutorialsState = {
  tutorials: [],
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
  error: null,
};

export const tutorialsReducer = createReducer(
  initTutorialsState,

  on(
    TutorialsActions.fetchTutorials.attempt,
    (state): TutorialsState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    TutorialsActions.fetchTutorials.success,
    (state, { tutorials }): TutorialsState => ({
      ...state,
      tutorials,
      loading: false,
      loaded: true,
    })
  ),

  on(
    TutorialsActions.fetchTutorials.error,
    (state, { error }): TutorialsState => ({
      ...state,
      tutorials: null,
      loading: false,
      loaded: true,
      error,
    })
  ),

  on(
    TutorialsActions.saveTutorials.attempt,
    (state, { tutorials }): TutorialsState => ({
      ...state,
      tutorials,
      saving: true,
      saved: false,
    })
  ),

  on(
    TutorialsActions.saveTutorials.success,
    (state): TutorialsState => ({
      ...state,
      tutorials: state.tutorials,
      saving: false,
      saved: true,
    })
  ),

  on(
    TutorialsActions.saveTutorials.error,
    (state, { error }): TutorialsState => ({
      ...state,
      tutorials: state.tutorials,
      saving: false,
      saved: true,
      error,
    })
  ),

  on(
    TutorialsActions.resetTutorial,
    (state, { tutorialType }): TutorialsState => {
      let newTutorials = state.tutorials.map((entry) => {
        if (entry.tutorialType === tutorialType) {
          return {
            ...entry,
            presented: false,
          };
        } else {
          return entry;
        }
      });

      return {
        ...state,
        tutorials: newTutorials,
      };
    }
  )
);
